<template>
  <el-container class="layout">
      <el-header>
          <Header />
      </el-header>
      <el-container>
          <el-aside width="320px">
              <el-tree
                  v-loading="tree.loading"
                  :data="tree.data"
                  :props="tree.defaultProps"
                  :indent="0"
                  @node-click="handleNodeClick"
              >
              </el-tree>
          </el-aside>
          <el-main>
            <div class="card-container">
              <el-card v-for="caseItem in table.cases" :key="caseItem.id" class="case-item">
        
                  <div class="case-name">{{ caseItem.CaseName }}</div>

                  <div class="info">
                     <span class="owner"><i class="el-icon-user"></i>{{ caseItem.owner_name }}</span>
                      <span class="download"><i class="el-icon-download"></i>{{ caseItem.downloadCount }}</span>
                      <span class="read"><i class="el-icon-view"></i>{{ caseItem.readCount }}</span>
                  </div>
                  
                  <el-button type="primary" size="mini" class="button" @click="ViewCase(caseItem.id)">查看</el-button>

              </el-card>
            </div>
          </el-main>
      </el-container>
      
  </el-container>
</template>

<script>

import CaseLibrary from "@/assets/js/CaseLibrary/CaseLibrary";

export default {
    ...CaseLibrary
};

</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  background-color: #ecf0f5;

  .el-header {
      background-color: #fff;
  }

  .el-container {
      height: calc(100% - 64px);
  }

  .el-main {
      background-color: #ecf0f5;
  }

  .el-aside {
      height: 100%;
      background-color: #fff;
      border: 1px solid #e6e6e6;
  }
}

/* 添加tree的虚线 */
.el-tree {
  color: #000;
}

/deep/ .el-tree-node > .el-tree-node__children {
  margin-left: 12px;
  border-left: 1px dashed #dcdcdc;
  background-color: transparent;
}

/deep/ .el-tree-node__expand-icon.is-leaf {
  color: #dcdcdc;

  &::before {
      content: "--";
  }
}

.card-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(auto, 1fr));
  gap: 20px; /* 设置卡片之间的间隔 */
}
.case-item {
  position: relative; /* 设置卡片为相对定位 */
  padding: 10px; /* 根据需要调整内边距 */

  line-height: 30px;

}
.case-item .case-name{
  font-size: large;
  
  top: 10px;
}

.case-item .info{
  color: #999999;
  font-size: xx-small;
  position:relative;
  display: flex;
  bottom: -20px; /* 距离底部的距离 */
  left: 00px; /* 距离右侧的距离 */
}
.case-item .info .download, .read, .orner {
    margin: 0 30px; /* 在左右两边添加10px的间隔 */
}
.case-item .info i {
    margin-right: 4px; /* 在图标和文字之间添加间隔 */
}
.case-item .button{
  position: absolute;
  bottom: 20px; /* 距离底部的距离 */
  right: 20px; /* 距离右侧的距离 */
}
</style>
